export default __webpack_public_path__ + "static/media/complete-sphere-loop.3e2b8a36.wav";